import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { WizardService } from './wizard.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { max, reduce } from 'ramda/es';
export interface ICol {
  title: string;
  icon: string;
  option: string;
  info?: string;
  description: string[];
}
export interface IWizardCol {
  title: string;
  isFirst?: boolean;
  isLast?: boolean;
  cols: ICol[];
  subscription: BehaviorSubject<any>;
}
@Component({
  selector: 'wizard-col',
  templateUrl: './wizard-col.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardColComponent implements OnInit {
  @Input() props: IWizardCol;
  private option: any;

  constructor(private wizardService: WizardService) {}

  ngOnInit() {
    this.changeActive(this.props.cols[0].option);
  }

  getPopoverPos(index: number): string {
    const half = this.props.cols.length / 2;
    if (index < half) {
      return 'right';
    }
    if (index >= half) {
      return 'left';
    }
    return 'auto';
  }

  getTileStyle = (col: ICol) => ({
    'col-sm-12': this.props.cols.length === 1,
    'col-sm-6 ': this.props.cols.length === 2,
    'col-sm-4': this.props.cols.length === 3,
    'col-sm-6 group4': this.props.cols.length === 4
  });

  changeActive(option: any) {
    this.option = option;
    this.props.subscription.next(option);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/wizard/wizard-col.component.ts